import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { BookmarkCategory } from '../../models/bookmark-category';
import { withBookmarkCategorySelectors } from './bookmark-category.selectors';
import { BookmarkCategoryService } from '../../services/bookmark-category/bookmark-category.service';
import { effect, inject } from '@angular/core';
import { ActiveUserStore } from '../user/active-user.state';
import { BookmarkStore } from '../bookmark/bookmark.state';
import { StoryStore } from '../story/story.state';
import { withLogging } from '../features/logger.feature';
import { withWorkspaceHelpers } from '../workspace-helper.selectors';

export type BookmarkCategoryState = BaseState<BookmarkCategory>;

export const initialState: BookmarkCategoryState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'BookmarkCategory',
  entityLabel: 'Themenbereich',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const BookmarkCategoryStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<BookmarkCategory>(BookmarkCategoryService),
  withLogging(initialState.entityType),
  withWorkspaceHelpers(),
  withMethods(store => ({
    isPrivate(categoryId: string) {
      return store.items()[categoryId]?.private || false;
    },
  })),
  withBookmarkCategorySelectors(),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // This store is reachable very early, before any commune is known:
      // the always-mounted ToolOverlayComponent injects RoutingService,
      // whose constructor injects TopicHelperService, which field-injects
      // this store directly - well before the public-Atlas route guard
      // resolves the commune from the slug. Watch for commune to become
      // available (or change) instead of firing once at construction.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
